import React from 'react';
import './content-list-item.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const ContentListItem = ({
  contentItem
}) => {
  return (
    <div className='g-list-item content-list-item'>
      {
        (contentItem) &&
        <div className='content-item'>
          <div className='content-item__image'>
            <ImageContainer
              src={contentItem.data.url}
              preview={true}
              containerHeight={'48px'}
              containerWidth={'48px'} />
          </div>
          <div className='content-item__data'>
            <div className='content-item__data__field'>
              <span className='field-label'>Name:</span>
              <span className='field-value'>{contentItem.data.name}</span>
            </div>
            <div className='content-item__data__field meta'>
              <span className='field-label'>ID:</span>
              <span className='field-value'>{contentItem.id}</span>
            </div>
            {/* <div className='content-item__data__field'>
              <span className='field-label'>Type:</span>
              <span className='field-value'>{contentItem.type}</span>
            </div> */}
            <div className='content-item__data__field meta'>
              <span className='field-label'>Created:</span>
              <span className='field-value'>{new Date(contentItem.ts).toLocaleString()}</span>
            </div>
          </div>
          <div className='content-item__category-data'>
            <div className='content-item__data__field'>
              <span className='field-label'>Category:</span>
              <span className='field-value'>{contentItem.cat}</span>
              </div>
            <div className='content-item__data__field'>
              <span className='field-label'>Directories:</span>
              <span className='field-value'>{contentItem.dir.join(', ')}</span>
            </div>
            {
              (contentItem.type === 'image') &&
              <div className='content-item__data__field'>
                <span className='field-label'>Cropped:</span>
                <span className='field-value'>{contentItem.cropped ? contentItem.cropped.toString().toUpperCase() : 'FALSE'}</span>
              </div>
            }
            {
              (contentItem.type === 'game') &&
              <div className='content-item__data__field'>
                <span className='field-label'>Access Level:</span>
                <span className='field-value'>{contentItem.accessLevel ? contentItem.accessLevel.toString().toUpperCase() : 'FREE'}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  )
}

export default ContentListItem